export enum CountryCategory {
  NA = 'North America',
  EMEA = 'Europe, Middle East, Africa',
  UK = 'United Kingdom',
  APAC = 'Asia Pacific',
  LATAM = 'Latin America',
}
